import { formatColumnDate } from '../../lib/utils';
import { ColDef } from 'ag-grid-community';

export const StockSplit = [
  {
    cellClass: 'ticker-cell',
    field: 'date_ex',
    headerName: 'Ex-Date',
    initialSort: 'asc' as ColDef['initialSort'],
    valueFormatter: ({ data }: any) => formatColumnDate(data.date_ex),
    valueGetter: ({ data }: any) => {
      if (!data.date_ex) return null;

      return data.date_ex;
    },
    width: 90,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellRendererParams: {
      tickerLogoVisible: true,
    },
    field: 'ticker',
    width: 100,
  },
  {
    cellClass: 'ticker-cell',
    field: 'exchange',
    width: 80,
  },
  {
    cellClass: 'ticker-cell',
    field: 'ratio',
    headerName: 'Split Ratio',
    width: 80,
  },
  {
    cellClass: 'ticker-cell',
    field: 'date_announced',
    headerName: 'Date Announced',
    valueFormatter: ({ data }: any) => formatColumnDate(data.date_announced),
    valueGetter: ({ data }: any) => {
      if (!data.date_announced) return null;

      return data.date_announced;
    },
    width: 100,
  },
  {
    cellClass: 'ticker-cell',
    field: 'date_recorded',
    headerName: 'Date Recorded',
    valueFormatter: ({ data }: any) => formatColumnDate(data.date_recorded),
    valueGetter: ({ data }: any) => {
      if (!data.date_recorded) return null;

      return data.date_recorded;
    },
    width: 100,
  },
  {
    cellClass: 'ticker-cell',
    field: 'date_distribution',
    headerName: 'Distribution Date',
    valueFormatter: ({ data }: any) => formatColumnDate(data.date_distribution),
    valueGetter: ({ data }: any) => {
      if (!data.date_distribution) return null;

      return data.date_distribution;
    },
    width: 100,
  },
];
